import { OrgUser, UserPermissions } from '@/types';

export const mockOrgUsers: OrgUser[] = [
    {
        id: 'ssullenberger@demo.com',
        email: 'ssullenberger@demo.com',
        firstName: 'Sully',
        lastName: 'Sullenberger',
        groups: ['engineer', 'pilot', 'e3e915dc-ef2e-42f2-9311-820dcf060cc5'],
        permissions: [UserPermissions.Admin],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota', 'voyager-ota'],
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-sully.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-sully.png',
        },
    },
    {
        id: 'aearhart@demo.com',
        email: 'aearhart@demo.com',
        firstName: 'Amelia',
        lastName: 'Earhart',
        groups: ['em', 'pilot', 'approver', 'e3e915dc-ef2e-42f2-9311-820dcf060cc5'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota', 'voyager-ota'],
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-amelia.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-amelia.png',
        },
    },
    {
        id: 'narmstrong@demo.com',
        email: 'narmstrong@demo.com',
        firstName: 'Neil',
        lastName: 'Armstrong',
        groups: ['qa', 'pilot', 'e3e915dc-ef2e-42f2-9311-820dcf060cc4'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota', 'voyager-ota'],
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-neil.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-neil.png',
        },
    },
    {
        id: 'mjemison@demo.com',
        email: 'mjemison@demo.com',
        firstName: 'Mae',
        lastName: 'Jemison',
        groups: ['cx', 'ops'],
        permissions: [],
        appIds: ['mercury', 'gemini', 'appollo-ios', 'appollo-android', 'appollo-react-native-ota', 'voyager-ota'],
        commsAvatars: {
            image32: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-mae.png',
            image48: 'https://runway-img.s3.us-east-2.amazonaws.com/avatar-mae.png',
        },
    },
];
